import theme from '../../theme/theme';

const {
  colors: { appBackground },
} = theme;

const styles = {
  header: {
    width: '100%',
    height: '3em',
    position: 'absolute',
    top: '0',
    backgroundColor: appBackground,
    zIndex: '1001',
  },
  root: {
    color: '#fff',
  },
};

export default styles;
